import { ChevronRight } from 'lucide-react';
import { FileNode } from '@/lib/fileUtils';
import { useTranslation } from 'react-i18next';

export interface FileBreadcrumbProps {
  currentPath: FileNode[];
  onBreadcrumbClick: (index: number) => void;
}

export function FileBreadcrumb({
  currentPath,
  onBreadcrumbClick,
}: FileBreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1 text-sm text-gray-500 min-w-0 flex-shrink">
      <button
        onClick={() => onBreadcrumbClick(-1)}
        className="hover:text-gray-700 flex-shrink-0 whitespace-nowrap"
      >
        {t('project.root')}
      </button>
      {currentPath.map((node, index) => (
        <span key={node.id} className="flex items-center gap-1 min-w-0">
          <ChevronRight size={14} className="flex-shrink-0" />
          <button
            onClick={() => onBreadcrumbClick(index)}
            className="hover:text-gray-700 truncate max-w-[120px]"
            title={node.name}
          >
            {node.name}
          </button>
        </span>
      ))}
    </div>
  );
}

export default FileBreadcrumb;
